export function parseBooleanDef() {
    return {
        type: "boolean",
    };
}
